import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

function Group({
  align = 'center',
  children,
  gap = 1,
  grow = 0,
  justify = 'flex-start',
  wrap = 'wrap',
  groupProps = {},
}) {
  const theme = Mui.useTheme();

  return (
    <Mui.Box
      display="flex"
      alignItems={align}
      justifyContent={justify}
      flexGrow={grow}
      flexWrap={wrap}
      gridGap={theme.spacing(gap)}
      {...groupProps}>
      {children}
    </Mui.Box>
  );
}

Group.propTypes = {
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  children: PropTypes.node,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  grow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  justify: PropTypes.oneOf([
    'flex-start',
    'center',
    'flex-end',
    'space-between',
    'space-around',
    'space-evenly',
  ]),
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse', 'inherit', 'initial', 'unset']),
  groupProps: PropTypes.object,
};

export default Group;
